import React, { useMemo, useState } from "react";
import { useOrdersListUIContext } from "../OrdersListUIContext";
import { isEqual } from "lodash";
import { Formik } from "formik";
import DatePicker from "react-multi-date-picker";
import persianCalender from "react-date-object/calendars/persian";
import persianCalender_fa from "react-date-object/locales/persian_fa";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";

const prepareFilter = (queryParams, values) => {
  const { status, searchText, startDate, endDate } = values;

  const newQueryParams = { ...queryParams };
  const filter = {};

  filter.status = status !== "" ? +status : undefined;

  if (searchText) {
    filter.name = searchText;
  }

  if (startDate && endDate) {
    filter.startDate = startDate;
    filter.endDate = endDate;
  }

  newQueryParams.filter = filter;
  return newQueryParams;
};

export function OrderListFilter({ listLoading }) {
  const [dates, setDates] = useState([]);

  const orderListUIContext = useOrdersListUIContext();
  const usersUIProps = useMemo(() => {
    return {
      queryParams: orderListUIContext.queryParams,
      setQueryParams: orderListUIContext.setQueryParams,
    };
  }, [orderListUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(usersUIProps.queryParams, values);

    if (!isEqual(newQueryParams, usersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      usersUIProps.setQueryParams(newQueryParams);
    }
  };

  const handleDateChange = (selectedDates, setFieldValue, handleSubmit) => {
    if (selectedDates.length === 2) {
      const [start, end] = selectedDates.map((date) => {
        const dateOnly = new Date(date.toDate()).toISOString().split("T")[0];

        return dateOnly;
      });

      setFieldValue("startDate", start);
      setFieldValue("endDate", end);

      setDates(selectedDates);

      handleSubmit();
    }
  };

  const resetDateHandler = (setFieldValue, handleSubmit) => {
    setFieldValue("startDate", "");
    setFieldValue("endDate", "");
    setDates([]);
    handleSubmit();
  };

  return (
    <>
      <Formik
        initialValues={{
          status: "",
          searchText: "",
          startDate: "",
          endDate: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({ values, handleSubmit, handleBlur, setFieldValue }) => (
          <form onSubmit={handleSubmit} className={"form form-label-right"}>
            <div className={"form-group row"} style={{ gap: "8px" }}>
              <div className={"col-lg-2"}>
                <select
                  className={"form-control"}
                  name={"status"}
                  placeholder={"فیلتر بر اساس وضعیت دسترسی"}
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value={""}>همه</option>
                  <option value={"0"}>ثبت اولیه</option>
                  <option value={"1"}>ثبت نهایی</option>
                  <option value={"2"}>ارسال شده</option>
                </select>
                <small className={"form-text text-muted"}>
                  <b>فیلتر</b> بر اساس وضعیت سفارش
                </small>
              </div>

              <div className={"col-lg-2"}>
                <input
                  type={"text"}
                  className={"form-control"}
                  name={"searchText"}
                  placeholder={"جستجو"}
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className={"form-text text-muted"}>
                  <b>جستجو</b> در همه فیلد ها
                </small>
              </div>

              <div className={"col-lg-3 form-control w-100"}>
                <div className="d-flex justify-content-between">
                  <DatePicker
                    value={dates}
                    onChange={(selectedDates) =>
                      handleDateChange(
                        selectedDates,
                        setFieldValue,
                        handleSubmit
                      )
                    }
                    range
                    style={{
                      width: "100%",
                      border: "none",
                      cursor: "pointer",
                      marginBottom: "8px",
                      boxShadow: "none",
                    }}
                    placeholder="انتخاب تاریخ"
                    calendar={persianCalender}
                    locale={persianCalender_fa}
                  />

                  <button
                    type="button"
                    onClick={() =>
                      resetDateHandler(setFieldValue, handleSubmit)
                    }
                    style={{
                      borderRadius: "8px",
                      transform: "translateY(-5px)",
                      border: "1px solid rgba(0, 0, 0, 0.8)",
                    }}
                    className="w-30px h-30px bg-white p-0 mt-0 font-weight-bold"
                  >
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Files/CloseCircle.svg"
                      )}
                    />
                  </button>
                </div>
                <small className={"form-text text-muted"}>
                  <b>فیلتر</b> بر اساس تاریخ
                </small>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
